import moment from 'moment';
import * as types from "./actions";
import { ORDER_ALL, PROPOSAL_ID_LABEL, PROPOSAL_ID, PROPOSAL_NAME_LABEL, PROPOSAL_NAME, DEFAULT_PAGE_SIZE, DAYS,DEFAULT_PAGE_NUM } from '../../../../utils/constants';
import { ORDER } from '../routes';

const defaultState = {
    list: [],
    page: DEFAULT_PAGE_NUM,
    path: ORDER,
    pageCount: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    tableHeader: [
        {
            label: "対象",
            checkbox: true
        },
        {
            label: "処理状況",
            button: false,
            id: true
        },
        {
            label: "発注締日",
            button: false
        },
        {
            label: "締時刻",
            button: false
        },
        {
            label: "納品日",
            button: false
        },
        {
            label: "商品提案グループ名",
            button: false
        },
        {
            label: "受注済店舗",
            button: false,
            rightAlign: true
        },
        {
            label: "明細",
            button: true
        }
    ],
    tableColumns: [
        "checkbox",
        "deadline",
        "closingDate",
        "closingTime",
        "delivery",
        "proposalName",
        "shops",
    ],
    proposalList: [],
    proposalAll: [
        {
            proposalId: "ALL",
            proposalName: "（"+ORDER_ALL+"）",
        }
    ],
    proposalHeader: [
        {
            label: "商品提案\nグループID",
            button: false,
            id: true
        },
        {
            label: "商品提案グループ名",
            button: false
        },
        {
            label: "選択",
            button: true
        }
    ],
    proposalColumns: [
        "proposalId",
        "proposalName",
    ],
    searchFields:[
        {
            label: PROPOSAL_ID_LABEL,
            name: PROPOSAL_ID
        }, {
            label: PROPOSAL_NAME_LABEL,
            name: PROPOSAL_NAME
        }
    ],
    filterStartDate: moment(),
    filterEndDate: moment().add(1, DAYS),
    processing: ORDER_ALL,
    proposalId: ORDER_ALL,
    proposalName:  "（"+ORDER_ALL+"）"
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.LIST:
            return { ...state, list: action.payload.list, pageCount: action.payload.pageCount };
        case types.PROPOSAL:
            return { ...state, proposalList: action.payload };
        case types.PROPOSAL_ALL:
            return { ...state, proposalList: state.proposalAll.concat(action.payload)};
        case types.FILTER:
            return { ...state, 
                page: action.payload.page,
                proposalName: action.payload.proposalName,
                proposalId: action.payload.proposalId,
                processing: action.payload.processing,
                filterStartDate: action.payload.filterStartDate, 
                filterEndDate: action.payload.filterEndDate};
        case types.SIZE:
            return { ...state, pageSize: action.payload };
        case types.PAGE:
            return { ...state, page: action.page, path: action.path };
        default: // need this for default case
            return state
    }
};
